module.exports = __webpack_public_path__ + "static/img/planLeftImg.3062816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planLeftImg.png
// module id = xgfo
// module chunks = 2